module.exports = __webpack_public_path__ + "img/Menu-01.74c5b940.png";